import React from "react";

function FooterScrollBtn(props) {
  return (
    <button
      type="button"
      onMouseOver={() => props.setHover(true)}
      onMouseOut={() => props.setHover(false)}
      onClick={props.onClick}
    >
      <img src={props.src} alt="scroll down" className={props.className} />
    </button>
  );
}

export default FooterScrollBtn;
